import Pqp from "../3x1010/Pqp.js";
import Main from "./Main.js";
import Scene from "./Scene.js";
export default class MappaHud {

	constructor(userLang, callback) {
		this.userLang = userLang;
		this.callback = callback;
		this.btn = undefined;
		this.mc = undefined;
	}


	init() {
		let btn = jQuery("#template-trix-btn-map-hud-dummy").clone();
		if (Pqp.isMobile()) {
			btn = jQuery("#template-trix-btn-map-hud").clone();
		}
		btn.attr("id", "mapphu" + MappaHud.ENUM++);
		//jQuery(".js-trix1010").append(btn);
		jQuery(".js-sx", Main.that.ui).prepend(btn);
		this.btn = btn;
		btn.on("click", jQuery.proxy(this.showMap, this));


	}
	show() {
		TweenMax.to(this.mc, 0.5, {
			opacity: 1
		});

	}

	dismiss(o) {
		jQuery(".js-panels-hud", this.mc).css("pointer-events", "none");
		TweenMax.to(this.mc, 0.5, {
			opacity: 0,
			onComplete: jQuery.proxy(this.remove, this, o)
		});
	}


	showMap() {
		this.btn.off("click");
		Main.sfoca(true);
		Main.showInterface(false)

		let mc = jQuery("#template-trix-map-hud").clone();
		mc.attr("id", "bmapphu" + MappaHud.ENUM++);
		jQuery(".js-trix1010").append(mc);


		jQuery(".js-title", mc).html(Main.lbl("mapLegenda"));

		let attuale = Scene.getCurrentScene();


		// Piazza gli hotspot
		let a = SceneList.SCENE;
		let lHigh = false;
		let toAppend = new Array();
		let toHigh = new Array();

		let row = 0;
		let col = 0;

		for (let x = 0; x < a.length; x++) {
			// Patcha le posizioni ancora non piazzate
			if (a[x].top == "-1") {
				a[x].patchPosx = (col * (5) + 1) + "%"
				a[x].patchPosy = (row * (5) + 5) + "%"

				col++;
				if (col > 20) {
					col = 0;
					row++;
				}
			}
		}


		for (let x = 0; x < a.length; x++) {
			//if (a[x].showOnMap) {

			let hs = jQuery("#template-trix-hothud").clone();
			hs.attr("id", "huhs" + MappaHud.ENUM++);
			jQuery(".js-panel-hud", mc).append(hs);
			if (a[x].patchPosx) {
				hs.css({
					top: a[x].patchPosy,
					left: a[x].patchPosx
				});

			} else {

				hs.css({
					top: this.patchaPercTop(a[x].top),
					left: this.patchaPercLeft(a[x].left)
				});
			}
			// Cerca la caption adeguata
			let caption = a[x].caption;
			if (!a[x].showOnMap) {
				// cerca la caption di quello mostrato
				for (let p = 0; p < a.length; p++) {
					if (a[p].area == attuale.area) {
						if (a[p].showOnMap) {
							caption = a[p].caption;
							break;
						}
					}
				}

			}
			if (a[x].showOnMap) { // PQPDATOGLIERE
				jQuery(".js-caption", hs).html(caption);
			} else { // PQPDATOGLIERE
				jQuery(".js-caption", hs).html(""); // PQPDATOGLIERE
			} // PQPDATOGLIERE
			jQuery(".js-orienta", hs).hide();

			hs.on("click", jQuery.proxy(this.dismiss, this, {
				scene: a[x].spot
			}));
			if (a[x].area == attuale.area) {
				toHigh.push({
					spot: a[x].spot,
					mc: hs,
					data: a[x],
					show: a[x].showOnMap
				});
			} else {
				if (!a[x].showOnMap) { // PQPDATOGLIERE 
					hs.hide();
				} // PQPDATOGLIERE 
			}
			if (a[x].showOnMap) {

				let hsdesc = jQuery("#template-hub-entry").clone();
				hsdesc.attr("id", "huhs" + MappaHud.ENUM++);
				jQuery(".js-left", hsdesc).html(a[x].caption + ".");
				//jQuery(".js-left", hsdesc).html(a[x].caption + ". " + a[x]["title_" + this.userLang.toLowerCase()]);
				jQuery(".js-right", hsdesc).html(a[x]["title_" + this.userLang.toLowerCase()]);
				toAppend.push({
					caption: this.padr(a[x].caption, "0", 3),
					mc: hsdesc
				});
			}


			//}
		}


		toAppend.sort(function (a, b) {
			if (a.caption < b.caption)
				return -1;
			if (a.caption > b.caption)
				return 1;
			return 0;
		});

		// Lista ordinata
/*		for (let x = 0; x < toAppend.length; x++) {
			jQuery(".js-list", mc).append(toAppend[x].mc);
		}*/
		/*let cols = [[], [], [], [], []];
		for (let x = 0; x < toAppend.length; x++) {
			let n = x % 5;
			cols[n].push(toAppend[x].mc);
			//jQuery(".js-list", mc).append(toAppend[x].mc);
		}
		console.log(cols)

		for (let x = 0; x < cols[0].length; x++) {
			for (let y = 0; y < cols.length; y++) {
				jQuery(".js-list", mc).append(cols[x*5+y]);
			}
		}*/
		// Faccio prima a farlo a mano
		jQuery(".js-col-0", mc).append(toAppend[0].mc);
		jQuery(".js-col-0", mc).append(toAppend[1].mc);
		jQuery(".js-col-0", mc).append(toAppend[2].mc);
		jQuery(".js-col-0", mc).append(toAppend[3].mc);
		jQuery(".js-col-0", mc).append(toAppend[4].mc);
		jQuery(".js-col-0", mc).append(toAppend[5].mc);

		jQuery(".js-col-1", mc).append(toAppend[6].mc);
		jQuery(".js-col-1", mc).append(toAppend[7].mc);
		jQuery(".js-col-1", mc).append(toAppend[8].mc);
		jQuery(".js-col-1", mc).append(toAppend[9].mc);
		jQuery(".js-col-1", mc).append(toAppend[10].mc);
		jQuery(".js-col-1", mc).append(toAppend[11].mc);

		jQuery(".js-col-2", mc).append(toAppend[12].mc);
		jQuery(".js-col-2", mc).append(toAppend[13].mc);
		jQuery(".js-col-2", mc).append(toAppend[14].mc);
		jQuery(".js-col-2", mc).append(toAppend[15].mc);
		jQuery(".js-col-2", mc).append(toAppend[16].mc);
		jQuery(".js-col-2", mc).append(toAppend[17].mc);
		/*
		jQuery(".js-col-2", mc).append(toAppend[18].mc);
		jQuery(".js-col-2", mc).append(toAppend[19].mc);
		jQuery(".js-col-2", mc).append(toAppend[20].mc);
		jQuery(".js-col-2", mc).append(toAppend[21].mc);
		jQuery(".js-col-2", mc).append(toAppend[22].mc);
		jQuery(".js-col-2", mc).append(toAppend[23].mc);

		jQuery(".js-col-3", mc).append(toAppend[24].mc);
		jQuery(".js-col-3", mc).append(toAppend[25].mc);
		jQuery(".js-col-3", mc).append(toAppend[26].mc);
		jQuery(".js-col-3", mc).append(toAppend[27].mc);
		jQuery(".js-col-3", mc).append(toAppend[28].mc);
		jQuery(".js-col-3", mc).append(toAppend[29].mc);
		jQuery(".js-col-3", mc).append(toAppend[30].mc);
		jQuery(".js-col-3", mc).append(toAppend[31].mc);

		jQuery(".js-col-4", mc).append(toAppend[32].mc);
		jQuery(".js-col-4", mc).append(toAppend[33].mc);
		jQuery(".js-col-4", mc).append(toAppend[34].mc);
		jQuery(".js-col-4", mc).append(toAppend[35].mc);


		jQuery(".js-col-4", mc).append(toAppend[36].mc);
		jQuery(".js-col-4", mc).append(toAppend[37].mc);
		jQuery(".js-col-4", mc).append(toAppend[38].mc);
		jQuery(".js-col-4", mc).append(toAppend[39].mc);*/
		//jQuery(".js-col-4", mc).append(toAppend[40].mc);


		// Controlla l'highlight
		let lFound = false;
		let norienta = 0;
		for (let x = 0; x < toHigh.length; x++) {
			//console.log(toHigh[x].spot + " " + attuale.spot)
			if (toHigh[x].spot == attuale.spot) {
				toHigh[x].mc.addClass("trix-hothud-selected");
				lFound = true;
				norienta = x;
			} else {
				if (!toHigh[x].show) {
					toHigh[x].mc.hide();
				}
			}
		}
		if (!lFound) {
			if (toHigh.length > 0) {
				toHigh[0].mc.addClass("trix-hothud-selected");
			}
		}



		//this.orientaIndicatore(toHigh[0].mc, toHigh[0]);
		this.orientaIndicatore(toHigh[norienta].mc, toHigh[norienta]);

		//toHigh[0].mc.css("z-index", 10000);
		toHigh[norienta].mc.css("z-index", 10000);

		jQuery(".js-btn-close", mc).on("click", jQuery.proxy(this.dismiss, this, null));
		this.mc = mc;

		mc.css("opacity", 0);

		this.show();


	};


	orientaIndicatore(mc, o) {
		let indicatore = jQuery(".js-orienta", mc)
		indicatore.show();
		//let original = Main.that.getOrientamentoBySceneName("scene0");
		let original = { prealign: "0|0|0" };//this.getOrientamentoBySceneName("scene0");
		let current = Main.that.getOrientamentoBySceneName(Scene.getCurrentScene().name);
		let spanOriginal = parseFloat(original.prealign.split("|")[1]);
		let spanCurrent = parseFloat(current.prealign.split("|")[1]);
		//console.log("-----------")	

		let dif = spanOriginal - spanCurrent;
		//console.log("Dif: " + dif);
		//console.log(spanOriginal, spanCurrent);
		let view = Main.that.pano.get("view");
		let curAngle = view.hlookat
		let adjust = Math.floor(Math.abs(view.hlookat / 360));

		if (curAngle < 0) {
			curAngle += adjust * 360;
		} else {
			curAngle -= adjust * 360;
		}

		/*
		console.log(view.hlookat);
		console.log(adjust)
		console.log(curAngle);
		*/

		//let endAngle = dif - curAngle + 90

		//endAngle = curAngle;

		//console.log(o)
		let sfaso = PLUNGE_SETTINGS.customs.angle_span;
		if (!Pqp.isNullOrEmpty(o.data.adjustAngle)) {
			sfaso = o.data.adjustAngle;
		}
		let value = curAngle
		//value += PLUNGE_SETTINGS.customs.angle_span;
		value += sfaso;
		value -= dif;
		indicatore.css("transform", "rotate(" + value + "deg)");


	};

	patchaPercTop(top) {
		let tmp = parseFloat(top.split("%")[0]);
		//tmp -= 2.5;
		return tmp + "%";
	}
	patchaPercLeft(left) {
		let tmp = parseFloat(left.split("%")[0]);
		//tmp -= 1.7;
		return tmp + "%";

	}
	padr(sString, sChar, nQuanti) {
		var n;
		n = sString.length;
		for (var x = 0; x < (nQuanti - n); x++) {
			sString = sChar + sString;
		}
		return sString;
	};

	remove(o) {
		if (o) {
			this.gotoScene(o.scene);
		}
		this.btn.on("click", jQuery.proxy(this.showMap, this));
		this.mc.remove();
		Main.sfoca(false);
		Main.showInterface(true)

	}


	gotoScene(scene) {
		this.callback.call(null, {
			type: MappaHud.EVENT_GOTO_SCENE,
			spot: scene
		});
	}

	showWidget(lFlag) {
		if (lFlag) {
			this.btn.show();
		} else {
			this.btn.hide();
		}
	}
}

MappaHud.EVENT_GOTO_SCENE = "eventGotoScene";

MappaHud.ENUM = 0;
